import { render, staticRenderFns } from "./edit-photo-popup.vue?vue&type=template&id=4e9d0e0c&"
import script from "./edit-photo-popup.vue?vue&type=script&lang=js&"
export * from "./edit-photo-popup.vue?vue&type=script&lang=js&"
import style0 from "./edit-photo-popup.vue?vue&type=style&index=0&id=4e9d0e0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports